import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function Play(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M4 2.004v19.993c0 1.648 1.882 2.589 3.2 1.6l12-9.997a2 2 0 000-3.2L7.2.404C5.882-.586 4 .356 4 2.004"
  }));
}

export { Play };
//# sourceMappingURL=Play.js.map